module.exports = __webpack_public_path__ + "3022e1a2b21786b05a3d14ea7217b0a5.eot";


//////////////////
// WEBPACK FOOTER
// ./assets/fonts/proxima-nova/2E6388_4_0.eot
// module id = 210
// module chunks = 0